import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Repo } from "types/generated";

const SpaceliftVcsReposTableLabelsCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<Repo>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={repo.labels} />
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableLabelsCell;
